import React from 'react';
import { Navigate, Outlet, useOutletContext } from 'react-router-dom';

/**
 * Child routes under /partner require `partnerOwnAccess === true` from PartnerLayout outlet context.
 */
const PartnerOwnPortfolioGate = () => {
  const { partnerOwnAccess } = useOutletContext() || {};
  if (partnerOwnAccess !== true) {
    return <Navigate to="/partner/dashboard" replace />;
  }
  return <Outlet />;
};

export default PartnerOwnPortfolioGate;
